import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import classNames from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import memoize from 'memoize-one';
import TextInput from '../../TextInput';
import capitalize from '../../lib/capitalize';
import countries from '../../intl/messages/countries';

class ForeignAddressInput extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    tabIndex: PropTypes.number,
  };

  static defaultProps = {
    className: undefined,
    tabIndex: undefined,
  };

  onChange = fieldType => event => {
    const { value, onChange } = this.props.input;
    onChange({ ...value, [fieldType]: event.target.value });
  };

  getCountriesAlphabetically = memoize(locale => {
    const countryMessages = Object.keys(countries).map(countryCode => ({
      abbreviation: countryCode,
      message: this.props.intl.formatMessage({ id: countryCode }),
    }));

    return countryMessages.sort((a, b) =>
      a.message.localeCompare(b.message, locale, { ignorePunctuation: true }),
    );
  });

  getPropsForType(type, className) {
    const {
      input: { value },
      classes,
      meta,
      tabIndex,
    } = this.props;

    return {
      input: {
        value: value[type] || '',
        onChange: this.onChange(type),
      },
      label: (
        <FormattedMessage
          id={type === 'postalCode' ? 'addressForeignPostalCode' : `address${capitalize(type)}`}
        />
      ),
      className: classNames(classes.input, className),
      required: type !== 'line2',
      meta: {
        ...meta,
        error: meta && meta.error && meta.error[type],
      },
      name: type,
      tabIndex,
    };
  }

  render() {
    const { classes, className, intl } = this.props;

    return (
      <div className={className}>
        <div className={classes.row}>
          <TextInput {...this.getPropsForType('line1')} />
        </div>
        <div className={classes.row}>
          <TextInput {...this.getPropsForType('number', classes.halfWidth)} />
          <TextInput {...this.getPropsForType('city')} />
        </div>
        <div className={classes.row}>
          <TextInput {...this.getPropsForType('state', classes.halfWidth)} />
          <TextInput {...this.getPropsForType('countryCode')} variant="select">
            <option value="" disabled>
              {this.props.intl.formatMessage({ id: 'selectYourCountry' })}
            </option>
            {this.getCountriesAlphabetically(intl.locale).map(country => (
              <option value={country.abbreviation} key={country.abbreviation}>
                {country.message}
              </option>
            ))}
          </TextInput>
        </div>
        <div className={classes.row}>
          <TextInput {...this.getPropsForType('postalCode', classes.postalCode)} type="tel" />
        </div>
      </div>
    );
  }
}

const stylesheet = theme => ({
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    '&:not(:first-child)': {
      marginTop: theme.spacing.unit,
    },
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
    },
  },
  input: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      '&:not(:first-child)': {
        marginTop: theme.spacing.unit,
      },
    },
    [theme.breakpoints.up('sm')]: {
      '&:not(:first-child)': {
        marginLeft: theme.spacing.unit,
      },
    },
  },
  halfWidth: {
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
  },
  postalCode: {
    [theme.breakpoints.up('sm')]: {
      width: '40%',
    },
  },
});

export default compose(
  injectIntl,
  injectSheet(stylesheet),
)(ForeignAddressInput);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/AddressInput/ForeignAddressInput.js